import React from 'react';
import Navigation from './navigation';

export default class NotFound extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <Navigation {...this.props} />
                <div className="min-h-screen bg-gray-200 p-4">
                    <div className="bg-white rounded mt-8 p-8 overflow-hidden shadow-lg w-full md:w-4/5 mx-auto">
                        Page not found
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/not-found.js